import { useTranslation } from "react-i18next";
import { Row, Col, Nav, NavItem, NavLink } from "reactstrap";
import { openCookieSettings } from "../../services/analytics";

const Footer = () => {
  const { t } = useTranslation();
  return (
    <footer className="footer">
      <Row className="align-items-center justify-content-xl-between">
        <Col xl="6">
          <div className="copyright text-center text-xl-left text-muted">
            © {new Date().getFullYear()}{" "}
            <a
              className="font-weight-bold ml-1"
              href="https://futuredocument.com"
              rel="noopener noreferrer"
              target="_blank">
              
              Future Document
            </a>
          </div>
        </Col>

        <Col xl="6">
          <Nav className="nav-footer justify-content-center justify-content-xl-end">
            <NavItem>
              <NavLink
                href="https://futuredocument.com"
                rel="noopener noreferrer"
                target="_blank">
                
                Future Document
              </NavLink>
            </NavItem>

            <NavItem>
              <NavLink
                href="https://futuredocument.com"
                rel="noopener noreferrer"
                target="_blank">
                
                {t("coreText.footer.about")}
              </NavLink>
            </NavItem>

            <NavItem>
              <NavLink
                href="https://futuredocument.com"
                rel="noopener noreferrer"
                target="_blank">
                
                {t("coreText.footer.blog")}
              </NavLink>
            </NavItem>

            <NavItem>
              <NavLink
                href="https://futuredocument.com"
                rel="noopener noreferrer"
                target="_blank">
                
                {t("coreText.footer.legal")}
              </NavLink>
            </NavItem>

            <NavItem>
              <NavLink href="#" onClick={(e) => {e.preventDefault();openCookieSettings();}} data-testid="cookie-settings-link">
                {t("cookies.settingsLink")}
              </NavLink>
            </NavItem>
          </Nav>
        </Col>
      </Row>
    </footer>);

};

export default Footer;
